<template>
  <div class="login">
    <div class="login_image"></div>
    <div class="login_submit">
      <van-form @submit="onSubmit">
        <van-field
          v-model="username"
          name="账号"
          label="账号"
          label-width="45px"
          placeholder="请输入账号"
          :rules="[{ required: true, message: '请填写账号' }]"
        />
        <van-field
          v-model="password"
          type="password"
          name="密码"
          label-width="45px"
          label="密码"
          placeholder="请输入密码"
          :rules="[{ required: true, message: '请填写密码' }]"
        />
        <div style="margin: 16px">
          <van-button round block type="info" native-type="submit"
            >登 录</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import { login } from "@/api/modules/login.js";
export default {
  name: "loginview",
  data() {
    return {
      username: "",
      password: "",
    };
  },
  methods: {
    onSubmit() {
      // 在这里处理表单提交逻辑，例如发送请求到服务器进行验证
      // console.log("账号:", this.username);
      // console.log("密码:", this.password);
      // this.$router.push({ path: '/tabbar' });
      // 可以在这里添加发送请求的代码
      login({ username: this.username, password: this.password })
        .then((res) => {
          if (res.msg == "操作成功") {
            if (this.$router.app.$route.path !== "/tabbar") {
              localStorage.setItem("token", res.token);
              localStorage.setItem("isAuthenticated", "true");
              this.$toast.success("登录成功");
              this.$router.push({ path: "/tabbar" });
            } else {
              console.log("Already on /tabbar, no navigation needed.");
            }
          } else {
            this.$toast(res.msg);
          }
          // console.log(res.token);
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="scss">
.login {
  width: 100vw;
  height: 100vh;
  //   background: #f5f5f5;
  // background: red;
  background: url("https://goviewpro.goviewlink.com/cloudStorageStatic/19760/background.png");
  // no-repeat;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  // background-size: cover !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  text-align: center;
  align-items: center;
  box-sizing: border-box;
  .login_image {
    width: 280px;
    height: 104px;
    background-image: url("https://goviewpro.goviewlink.com/cloudStorageStatic/19760/biaoti.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: 74px;
    left: 48px;
  }
  .login_submit {
    padding-left: 25px;
    padding-right: 25px;
    width: 80%;
    height: 220px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 0.92;
    padding-top: 30px;
    padding-bottom: 30px;
    .van-field__label {
      color: #333333 !important;
      font-weight: 500 !important;
      font-size: 16px !important;
    }
    .van-cell::after {
      border-bottom: 1px solid #dedede !important;
    }
    .van-field__control::placeholder {
      font-weight: 400;
      font-size: 16px;
      color: #999999;
    }
    .van-button {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: linear-gradient(180deg, #4a90f6 0%, #3274f0 100%);
      border-radius: 5px 5px 5px 5px;
      border: none;
    }
  }
}
</style>
